import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { ContentJson } from '@/types/domain/privateBlog/entities/contentEntity';
import type { PrivateBlogJson } from '@/types/domain/privateBlog/entities/privateBlogEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import Content from '@/domain/privateBlog/component/ContentPrivateBlog';

/**
 * プロパティ
 */
export type Props = {
  /** 記事 */
  privateBlog: PrivateBlogJson,
  /** コンテンツ */
  content: ContentJson,
  /** カテゴリ */
  category: string,
  /** カテゴリ */
  publishDate: string,
  /**
   * 閉じる
   * @returns なし
   */
  close: () => void,
}

/**
 * 詳細
 * @param props プロパティ
 * @returns コンポーネント
 */
const Detail: React.FC<Props> = ({
  privateBlog,
  content,
  category,
  publishDate,
  close,
}) => (
  <Dialog
    open
    onClose={() => close()}
    TransitionComponent={DialogTransition}
    fullScreen
  >
    <DialogTitle title={`${category}`} />
    <DialogContent>
      <Content
        data={{ content, privateBlog, publishDate }}
      />
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close()} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default Detail;
